import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

// Rxjs
import { Observable } from 'rxjs';

// Models
import { LoanHistoryElementType } from './models';
import { routes } from '@model/constants/routes';

// Environment
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class HistoricService {
  private apiGatewayUrl: string;

  constructor(private http: HttpClient) {
    this.apiGatewayUrl = environment.apiGatewayUrl;
  }

  public getLoanHistory(): Observable<LoanHistoryElementType[]> {
    return this.http.get<LoanHistoryElementType[]>(
      `${this.apiGatewayUrl}credit-management/back-loaninformation/${routes.credit}/inactive`
    );
  }
}
